const apparelSizes = ["XXS", "XS", "S", "M", "L", "XL", "2XL"];
const sockSizes = ["35/38", "39/42"];
const oneSize = ["One size"];

const productData = [
  {
    id: 1,
    slug: "tee-flower",
    sku: "TL26-001",
    name: "tee flower",
    category: "T-shirts",
    price: 119.9,
    currency: "USD",
    image: "/img/products/01-tee-flower.jpg",
    images: ["/img/products/01-tee-flower.jpg"],
    description: [
      "A relaxed everyday tee animated by an original scattered flower motif in calm, sun-washed tones.",
      "The lightweight jersey feels soft against the skin and falls cleanly over trousers, skirts and layered looks.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["XXS", "2XL"],
    colors: ["Powder Pink", "Dark Fog"],
    attributes: {
      material: "100% organic cotton jersey",
      fit: "Relaxed fit",
      care: "Machine wash at 30°C with similar colours",
      sustainability: "Organic cotton",
    },
    features: [
      "Original tonal flower print",
      "Soft ribbed crew neckline",
      "Lightweight breathable finish",
    ],
    tags: ["new", "women", "t-shirts", "flower", "organic-cotton", "summer"],
    rating: 4.8,
    reviewCount: 38,
    stock: 42,
    isNew: true,
  },
  {
    id: 2,
    slug: "tailored-drawstring-pants",
    sku: "TL26-002",
    name: "tailored drawstring pants",
    category: "Pants",
    price: 189.9,
    currency: "USD",
    image: "/img/products/02-tailored-drawstring-pants.jpg",
    images: ["/img/products/02-tailored-drawstring-pants.jpg"],
    description: [
      "Relaxed high-waist trousers that combine the ease of a jogger with the line of softly tailored pants.",
      "Subtle front pleats and a fluid leg create an effortless shape for workdays, travel and weekends.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["XXS", "XL"],
    colors: ["Black", "Moonrock"],
    attributes: {
      material: "95% organic cotton, 5% elastane",
      fit: "Relaxed high-waist fit",
      care: "Machine wash at 30°C; reshape while damp",
      sustainability: "Organic cotton blend",
    },
    features: [
      "Elasticated drawstring waist",
      "Soft front pleats",
      "Angled side pockets",
    ],
    tags: ["women", "pants", "relaxed", "high-waist", "365", "signature"],
    rating: 4.7,
    reviewCount: 27,
    stock: 24,
    isNew: false,
  },
  {
    id: 3,
    slug: "cropped-sweater-flower",
    sku: "TL26-003",
    name: "cropped sweater flower",
    category: "Sweaters",
    price: 129.9,
    currency: "USD",
    image: "/img/products/03-cropped-sweater-flower.jpg",
    images: ["/img/products/03-cropped-sweater-flower.jpg"],
    description: [
      "A compact cropped sweater with a softly brushed interior and a hand-drawn botanical pattern created for this collection.",
      "Its boxy proportion balances high-rise pants and adds an easy layer over dresses or longer tees.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["2XL"],
    colors: ["Powder Pink", "Stone"],
    attributes: {
      material: "Organic cotton and modal fleece",
      fit: "Cropped relaxed fit",
      care: "Gentle machine wash at 30°C",
      sustainability: "Organic cotton content",
    },
    features: [
      "Original botanical artwork",
      "Soft brushed interior",
      "Wide ribbed hem and cuffs",
    ],
    tags: ["new", "women", "sweaters", "cropped", "flower"],
    rating: 4.9,
    reviewCount: 45,
    stock: 31,
    isNew: true,
  },
  {
    id: 4,
    slug: "statement-sweater",
    sku: "TL26-004",
    name: "statement sweater",
    category: "Sweaters",
    price: 129.9,
    currency: "USD",
    image: "/img/products/04-statement-sweater.jpg",
    images: ["/img/products/04-statement-sweater.jpg"],
    description: [
      "An oversized crew-neck sweater built around generous volume, dropped shoulders and a clean, text-free front.",
      "Dense cotton fleece gives the silhouette structure while remaining comfortable enough for everyday wear.",
    ],
    sizes: apparelSizes,
    colors: ["Ecru", "Dark Fog"],
    attributes: {
      material: "Heavy organic cotton fleece",
      fit: "Oversized fit",
      care: "Machine wash inside out at 30°C",
      sustainability: "Organic cotton",
    },
    features: [
      "Dropped shoulder construction",
      "Wide ribbed trims",
      "Soft looped interior",
    ],
    tags: ["women", "sweaters", "oversized", "essential", "365", "signature"],
    rating: 4.7,
    reviewCount: 61,
    stock: 37,
    isNew: false,
  },
  {
    id: 5,
    slug: "long-blouse",
    sku: "TL26-005",
    name: "long blouse",
    category: "Shirts",
    price: 179.9,
    currency: "USD",
    image: "/img/products/05-long-blouse.jpg",
    images: ["/img/products/05-long-blouse.jpg"],
    description: [
      "A longline blouse with a fluid drape, rounded hem and quiet tailoring through the shoulders.",
      "Wear it loose for an airy silhouette or half-tucked with a coordinating trouser for soft structure.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["XXS", "2XL"],
    colors: ["White", "Light Fudge"],
    attributes: {
      material: "Lyocell and linen blend",
      fit: "Oversized longline fit",
      care: "Gentle machine wash at 30°C; hang dry",
      sustainability: "Lower-impact lyocell blend",
    },
    features: [
      "Elongated curved hem",
      "Concealed button placket",
      "Lightweight breathable weave",
    ],
    tags: ["new", "women", "shirts", "longline", "co-ord", "summer"],
    rating: 4.6,
    reviewCount: 24,
    stock: 20,
    isNew: true,
  },
  {
    id: 6,
    slug: "woven-jogger",
    sku: "TL26-006",
    name: "woven jogger",
    category: "Pants",
    price: 139.9,
    currency: "USD",
    image: "/img/products/06-woven-jogger.jpg",
    images: ["/img/products/06-woven-jogger.jpg"],
    description: [
      "A refined woven jogger with an easy waistband and a tapered leg that keeps the look polished.",
      "The compact stretch fabric travels well and holds its shape from morning commutes to late dinners.",
    ],
    sizes: apparelSizes,
    colors: ["Stone", "Dark Fog"],
    attributes: {
      material: "Viscose-blend compact weave",
      fit: "Regular tapered fit",
      care: "Machine wash at 30°C; dry flat",
      sustainability: "Responsibly sourced viscose content",
    },
    features: [
      "Elasticated drawstring waist",
      "Tapered ankle length",
      "Deep side pockets",
    ],
    tags: ["women", "pants", "jogger", "travel", "365"],
    rating: 4.7,
    reviewCount: 33,
    stock: 36,
    isNew: false,
  },
  {
    id: 7,
    slug: "balloon-blouse",
    sku: "TL26-007",
    name: "balloon blouse",
    category: "Shirts",
    price: 119.9,
    currency: "USD",
    image: "/img/products/07-balloon-blouse.jpg",
    images: ["/img/products/07-balloon-blouse.jpg"],
    description: [
      "A softly rounded blouse shaped with pleated sleeves and a lightly gathered hem.",
      "Its smooth, fluid fabric balances the sculptural volume and layers comfortably beneath jackets.",
    ],
    sizes: apparelSizes,
    colors: ["Ecru", "Powder Pink"],
    attributes: {
      material: "100% lyocell twill",
      fit: "Relaxed balloon fit",
      care: "Gentle wash at 30°C; dry flat",
      sustainability: "Lyocell from responsibly managed sources",
    },
    features: [
      "Pleated balloon sleeves",
      "Soft gathered hem",
      "Keyhole back fastening",
    ],
    tags: ["new", "women", "shirts", "balloon", "lyocell", "summer"],
    rating: 4.8,
    reviewCount: 29,
    stock: 28,
    isNew: true,
  },
  {
    id: 8,
    slug: "western-pants-flower",
    sku: "TL26-008",
    name: "western pants flower",
    category: "Pants",
    price: 189.9,
    currency: "USD",
    image: "/img/products/08-western-pants-flower.jpg",
    images: ["/img/products/08-western-pants-flower.jpg"],
    description: [
      "Straight-leg pants detailed with curved western-inspired seams and a restrained original flower print.",
      "The softly structured twill creates a clean line while retaining enough stretch for all-day movement.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["S", "XL"],
    colors: ["Dark Fog", "Powder Pink"],
    attributes: {
      material: "Organic cotton and lyocell twill",
      fit: "Regular straight fit",
      care: "Machine wash inside out at 30°C",
      sustainability: "Organic cotton and lyocell blend",
    },
    features: [
      "Original tonal flower print",
      "Curved panel seams",
      "Comfort-stretch waistband",
    ],
    tags: ["new", "women", "pants", "flower", "western"],
    rating: 4.6,
    reviewCount: 18,
    stock: 22,
    isNew: true,
  },
  {
    id: 9,
    slug: "sweater-flower",
    sku: "TL26-009",
    name: "sweater flower",
    category: "Sweaters",
    price: 159.9,
    currency: "USD",
    image: "/img/products/09-sweater-flower.jpg",
    images: ["/img/products/09-sweater-flower.jpg"],
    description: [
      "A relaxed knit sweater with a softly scaled floral pattern that reads as texture from a distance.",
      "The breathable cotton-rich yarn makes it a comfortable layer through changing temperatures.",
    ],
    sizes: apparelSizes,
    colors: ["Light Fudge", "Powder Pink"],
    attributes: {
      material: "Cotton and viscose knit",
      fit: "Relaxed fit",
      care: "Cold gentle wash; reshape and dry flat",
      sustainability: "Responsibly sourced viscose content",
    },
    features: [
      "Original jacquard flower pattern",
      "Soft crew neckline",
      "Ribbed cuffs and hem",
    ],
    tags: ["new", "women", "sweaters", "knit", "flower"],
    rating: 4.8,
    reviewCount: 41,
    stock: 26,
    isNew: true,
  },
  {
    id: 10,
    slug: "socks-all-over-flower",
    sku: "TL26-010",
    name: "socks all-over flower",
    category: "Underwear & socks",
    price: 100,
    currency: "USD",
    image: "/img/products/10-socks-all-over-flower.jpg",
    images: ["/img/products/10-socks-all-over-flower.jpg"],
    description: [
      "Soft crew socks finished with a small-scale original flower motif and a comfortable ribbed cuff.",
      "A reinforced heel and toe make this playful everyday pair ready for repeat wear.",
    ],
    sizes: sockSizes,
    unavailableSizes: ["39/42"],
    colors: ["Powder Pink", "Ecru"],
    attributes: {
      material: "Organic cotton, recycled polyamide and elastane",
      fit: "Regular crew-sock fit",
      care: "Machine wash at 30°C",
      sustainability: "Organic cotton and recycled fibre blend",
    },
    features: [
      "Original all-over flower motif",
      "Reinforced heel and toe",
      "Soft ribbed cuff",
    ],
    tags: ["women", "accessories", "socks", "flower"],
    rating: 4.9,
    reviewCount: 54,
    stock: 78,
    isNew: false,
  },
  {
    id: 11,
    slug: "brushed-baseball-cardigan",
    sku: "TL26-011",
    name: "brushed baseball cardigan",
    category: "Cardigans",
    price: 179.9,
    currency: "USD",
    image: "/img/products/11-brushed-baseball-cardigan.jpg",
    images: ["/img/products/11-brushed-baseball-cardigan.jpg"],
    description: [
      "A brushed cardigan that translates classic baseball proportions into a soft, minimal everyday layer.",
      "The roomy body and snap front sit easily over tees, dresses and fine knits without feeling bulky.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["XXS", "XS"],
    colors: ["Light Fudge", "Dark Fog"],
    attributes: {
      material: "Brushed cotton-blend jersey",
      fit: "Oversized fit",
      care: "Gentle wash at 30°C; dry flat",
      sustainability: "Recycled polyester content",
    },
    features: [
      "Soft brushed surface",
      "Tonal snap-button front",
      "Deep welt pockets",
    ],
    tags: ["women", "cardigans", "baseball", "layering", "365", "signature"],
    rating: 4.8,
    reviewCount: 32,
    stock: 19,
    isNew: false,
  },
  {
    id: 12,
    slug: "tank-top-rib",
    sku: "TL26-012",
    name: "tank top rib",
    category: "Singlets",
    price: 109.9,
    currency: "USD",
    image: "/img/products/12-tank-top-rib.jpg",
    images: ["/img/products/12-tank-top-rib.jpg"],
    description: [
      "A close-fitting ribbed tank with a clean scoop neck and enough stretch to recover after every wear.",
      "Designed as a quiet base layer, it also works on its own with wide pants and relaxed tailoring.",
    ],
    sizes: apparelSizes,
    colors: ["White", "Black", "Stone"],
    attributes: {
      material: "95% organic cotton, 5% elastane",
      fit: "Slim fit",
      care: "Machine wash at 30°C",
      sustainability: "Organic cotton blend",
    },
    features: [
      "Flexible rib construction",
      "Clean scoop neckline",
      "Double-needle hem",
    ],
    tags: ["women", "singlets", "rib", "essential", "365", "signature"],
    rating: 4.8,
    reviewCount: 76,
    stock: 84,
    isNew: false,
  },
  {
    id: 13,
    slug: "loop-stitch-socks",
    sku: "TL26-013",
    name: "loop stitch socks",
    category: "Underwear & socks",
    price: 100,
    currency: "USD",
    image: "/img/products/13-loop-stitch-socks.jpg",
    images: ["/img/products/13-loop-stitch-socks.jpg"],
    description: [
      "Comfortable crew socks with an original flowing looped stitch motif created for this collection.",
      "A cushioned sole and smooth toe seam keep the pair comfortable throughout the day.",
    ],
    sizes: sockSizes,
    colors: ["Ecru", "Dark Fog"],
    attributes: {
      material: "Combed cotton, recycled polyamide and elastane",
      fit: "Regular crew-sock fit",
      care: "Machine wash at 30°C",
      sustainability: "Recycled fibre content",
    },
    features: [
      "Original looped stitch motif",
      "Cushioned sole",
      "Smooth linked toe seam",
    ],
    tags: ["women", "accessories", "socks", "everyday"],
    rating: 4.7,
    reviewCount: 49,
    stock: 92,
    isNew: false,
  },
  {
    id: 14,
    slug: "pleated-sweater",
    sku: "TL26-014",
    name: "pleated sweater",
    category: "Sweaters",
    price: 169.9,
    currency: "USD",
    image: "/img/products/14-pleated-sweater.jpg",
    images: ["/img/products/14-pleated-sweater.jpg"],
    description: [
      "An oversized sweater shaped with fine vertical pleats that add movement without introducing extra weight.",
      "The matte recycled jersey holds its texture and creates an elevated alternative to classic fleece.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["L", "2XL"],
    colors: ["Stone", "Dark Fog"],
    attributes: {
      material: "Recycled pleated jersey",
      fit: "Oversized fit",
      care: "Cold gentle wash; do not iron pleats",
      sustainability: "Recycled fibre blend",
    },
    features: [
      "Permanent micro-pleat texture",
      "Dropped shoulders",
      "Side-slit hem",
    ],
    tags: ["women", "sweaters", "pleated", "texture"],
    rating: 4.6,
    reviewCount: 21,
    stock: 17,
    isNew: false,
  },
  {
    id: 15,
    slug: "balloon-pants",
    sku: "TL26-015",
    name: "balloon pants",
    category: "Pants",
    price: 189.9,
    currency: "USD",
    image: "/img/products/15-balloon-pants.jpg",
    images: ["/img/products/15-balloon-pants.jpg"],
    description: [
      "High-rise pants with a curved balloon leg that creates volume through the hip before tapering at the ankle.",
      "A supple lyocell blend keeps the sculptural shape fluid and comfortable in motion.",
    ],
    sizes: apparelSizes,
    colors: ["Black", "Light Fudge"],
    attributes: {
      material: "Stretch lyocell twill",
      fit: "Relaxed balloon fit",
      care: "Gentle machine wash at 30°C",
      sustainability: "Lyocell-rich blend",
    },
    features: [
      "Curved balloon-leg seams",
      "High-rise elasticated back waist",
      "Inset side pockets",
    ],
    tags: ["new", "women", "pants", "balloon", "high-waist"],
    rating: 4.7,
    reviewCount: 26,
    stock: 23,
    isNew: true,
  },
  {
    id: 16,
    slug: "bandana-knit-scarf",
    sku: "TL26-016",
    name: "bandana knit scarf",
    category: "Scarves",
    price: 119.9,
    currency: "USD",
    image: "/img/products/16-bandana-knit-scarf.jpg",
    images: ["/img/products/16-bandana-knit-scarf.jpg"],
    description: [
      "A triangular knit scarf that brings a soft point of colour to simple layers and tonal outfits.",
      "Its compact cotton construction feels smooth at the neck and folds neatly into a travel bag.",
    ],
    sizes: oneSize,
    colors: ["Powder Pink", "Dark Fog"],
    attributes: {
      material: "100% cotton knit",
      fit: "One size",
      care: "Cold hand wash; dry flat",
      sustainability: "Long-staple cotton",
    },
    features: [
      "Triangular bandana shape",
      "Fine-gauge knit",
      "Soft rolled edge",
    ],
    tags: ["women", "accessories", "scarves", "knit"],
    rating: 4.8,
    reviewCount: 19,
    stock: 44,
    isNew: false,
  },
  {
    id: 17,
    slug: "hooded-travel-jacket",
    sku: "TL26-017",
    name: "hooded travel jacket",
    category: "Jackets",
    price: 239.9,
    currency: "USD",
    image: "/img/products/17-hooded-travel-jacket.jpg",
    images: ["/img/products/17-hooded-travel-jacket.jpg"],
    description: [
      "A streamlined hooded jacket cut from resilient stretch fabric designed to move easily and resist creasing.",
      "The pared-back shape layers over matching travel pants for a comfortable, coordinated silhouette.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["XXS", "2XL"],
    colors: ["Black", "Dark Fog"],
    attributes: {
      material: "Recycled technical jersey with elastane",
      fit: "Relaxed fit",
      care: "Machine wash at 30°C; hang dry",
      sustainability: "Recycled polyamide content",
    },
    features: [
      "Adjustable three-panel hood",
      "Two-way front zip",
      "Secure zipped pockets",
    ],
    tags: ["women", "jackets", "travel", "technical", "365"],
    rating: 4.9,
    reviewCount: 35,
    stock: 16,
    isNew: false,
  },
  {
    id: 18,
    slug: "easy-travel-pants",
    sku: "TL26-018",
    name: "easy travel pants",
    category: "Pants",
    price: 169.9,
    currency: "USD",
    image: "/img/products/18-easy-travel-pants.jpg",
    images: ["/img/products/18-easy-travel-pants.jpg"],
    description: [
      "Smooth travel pants with a slim, unfussy line and four-way stretch for long days on the move.",
      "The crease-resistant jersey returns to shape quickly and pairs naturally with the hooded travel jacket.",
    ],
    sizes: apparelSizes,
    colors: ["Black", "Dark Fog"],
    attributes: {
      material: "Recycled stretch travel jersey",
      fit: "Slim fit",
      care: "Machine wash at 30°C; hang dry",
      sustainability: "Recycled polyamide content",
    },
    features: [
      "Four-way stretch",
      "Crease-resistant finish",
      "Comfortable elastic waist",
    ],
    tags: ["women", "pants", "travel", "slim", "365", "signature"],
    rating: 4.8,
    reviewCount: 63,
    stock: 39,
    isNew: false,
  },
  {
    id: 19,
    slug: "lyocell-shirt",
    sku: "TL26-019",
    name: "lyocell shirt",
    category: "Shirts",
    price: 159.9,
    currency: "USD",
    image: "/img/products/19-lyocell-shirt.jpg",
    images: ["/img/products/19-lyocell-shirt.jpg"],
    description: [
      "A fluid button-front shirt with a softly washed surface and a relaxed shape through the body.",
      "The breathable lyocell twill drapes cleanly whether worn open as a light layer or tucked into pants.",
    ],
    sizes: apparelSizes,
    colors: ["Light Fudge", "Stone"],
    attributes: {
      material: "100% lyocell twill",
      fit: "Relaxed fit",
      care: "Gentle wash at 30°C; hang dry",
      sustainability: "Lyocell from responsibly managed sources",
    },
    features: [
      "Washed fluid handle",
      "Concealed chest pocket",
      "Rounded side-slit hem",
    ],
    tags: ["women", "shirts", "lyocell", "co-ord"],
    rating: 4.7,
    reviewCount: 31,
    stock: 25,
    isNew: false,
  },
  {
    id: 20,
    slug: "banana-pants-lyocell",
    sku: "TL26-020",
    name: "banana pants lyocell",
    category: "Pants",
    price: 179.9,
    currency: "USD",
    image: "/img/products/20-banana-pants-lyocell.jpg",
    images: ["/img/products/20-banana-pants-lyocell.jpg"],
    description: [
      "Relaxed lyocell pants with a gently curved banana leg and subtle shaping through the knee.",
      "The fluid twill brings softness to the sculpted silhouette and makes the pants easy to dress up or down.",
    ],
    sizes: apparelSizes,
    colors: ["Dark Fog", "Stone"],
    attributes: {
      material: "Lyocell twill",
      fit: "Relaxed banana fit",
      care: "Gentle machine wash at 30°C",
      sustainability: "Lower-impact cellulosic fibre",
    },
    features: [
      "Curved banana-leg silhouette",
      "Soft front tucks",
      "Elasticated back waist",
    ],
    tags: ["women", "pants", "banana-fit", "lyocell"],
    rating: 4.8,
    reviewCount: 37,
    stock: 29,
    isNew: false,
  },
  {
    id: 21,
    slug: "arc-tech-pants",
    sku: "TL26-021",
    name: "arc tech pants",
    category: "Pants",
    price: 160,
    currency: "USD",
    image: "/img/products/21-arc-tech-pants.jpg",
    images: ["/img/products/21-arc-tech-pants.jpg"],
    description: [
      "Technical everyday pants with a clean tapered line, articulated knees and enough stretch for unrestricted movement.",
      "The matte, resilient fabric keeps its shape through commuting, travel and long off-duty days.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["XXS"],
    colors: ["Black", "Steel Blue"],
    attributes: {
      material: "Recycled polyamide stretch twill",
      fit: "Regular tapered fit",
      care: "Machine wash at 30°C; hang dry",
      sustainability: "Recycled technical fibre blend",
    },
    features: [
      "Four-way comfort stretch",
      "Articulated knee construction",
      "Secure zipped side pocket",
    ],
    tags: ["men", "pants", "technical", "travel"],
    rating: 4.7,
    reviewCount: 31,
    stock: 24,
    isNew: false,
  },
  {
    id: 22,
    slug: "canvas-overshirt",
    sku: "TL26-022",
    name: "canvas overshirt",
    category: "Shirts",
    price: 180,
    currency: "USD",
    image: "/img/products/22-canvas-overshirt.jpg",
    images: ["/img/products/22-canvas-overshirt.jpg"],
    description: [
      "A relaxed overshirt with the substance of a light jacket and the familiar ease of a button-front shirt.",
      "The washed canvas softens with wear and layers comfortably over tees, knitwear and travel pieces.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["2XL"],
    colors: ["Ecru", "Dusty Olive"],
    attributes: {
      material: "Organic cotton canvas",
      fit: "Relaxed overshirt fit",
      care: "Machine wash at 30°C; reshape while damp",
      sustainability: "Organic cotton",
    },
    features: [
      "Two utility chest pockets",
      "Tonal snap-button fastening",
      "Curved side-slit hem",
    ],
    tags: ["men", "shirts", "overshirt", "layering"],
    rating: 4.8,
    reviewCount: 22,
    stock: 18,
    isNew: false,
  },
  {
    id: 23,
    slug: "heavy-jersey-tee",
    sku: "TL26-023",
    name: "heavy jersey tee",
    category: "T-shirts",
    price: 100,
    currency: "USD",
    image: "/img/products/23-heavy-jersey-tee.jpg",
    images: ["/img/products/23-heavy-jersey-tee.jpg"],
    description: [
      "A substantial crew-neck tee cut from compact heavyweight jersey for a crisp, dependable silhouette.",
      "Dropped shoulders and a balanced length make it an easy foundation for relaxed trousers and layered jackets.",
    ],
    sizes: apparelSizes,
    colors: ["White", "Black"],
    attributes: {
      material: "Heavyweight organic cotton jersey",
      fit: "Relaxed fit",
      care: "Machine wash inside out at 30°C",
      sustainability: "Organic cotton",
    },
    features: [
      "Compact heavyweight handle",
      "Reinforced ribbed neckline",
      "Dropped shoulder construction",
    ],
    tags: ["men", "t-shirts", "heavy-jersey", "essential"],
    rating: 4.8,
    reviewCount: 40,
    stock: 36,
    isNew: false,
  },
  {
    id: 24,
    slug: "brushed-fleece-sweater",
    sku: "TL26-024",
    name: "brushed fleece sweater",
    category: "Sweaters",
    price: 140,
    currency: "USD",
    image: "/img/products/24-brushed-fleece-sweater.jpg",
    images: ["/img/products/24-brushed-fleece-sweater.jpg"],
    description: [
      "A relaxed fleece sweater with a clean crew neckline and softly structured volume through the body.",
      "The brushed interior provides warmth without heaviness, making it a dependable layer across seasons.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["XXS", "2XL"],
    colors: ["Dark Grey", "Ecru"],
    attributes: {
      material: "Organic cotton brushed fleece",
      fit: "Relaxed fit",
      care: "Machine wash inside out at 30°C",
      sustainability: "Organic cotton",
    },
    features: [
      "Soft brushed interior",
      "Dropped shoulder seams",
      "Resilient ribbed trims",
    ],
    tags: ["men", "sweaters", "fleece", "everyday"],
    rating: 4.8,
    reviewCount: 34,
    stock: 28,
    isNew: false,
  },
  {
    id: 25,
    slug: "cedar-amber-room-spray-500ml",
    sku: "TL26-025",
    name: "cedar amber room spray 500ml",
    category: "Room sprays",
    price: 129.9,
    currency: "USD",
    image: "/img/products/25-cedar-amber-room-spray.jpg",
    images: ["/img/products/25-cedar-amber-room-spray.jpg"],
    description: [
      "A generous room spray composed around dry cedar, mineral amber and a quiet trace of green leaves.",
      "A few fine mists bring a calm, clean atmosphere to living spaces without becoming overpowering.",
    ],
    sizes: oneSize,
    colors: ["Smoked Amber"],
    attributes: {
      material: "Fragrance blend in a recyclable glass bottle",
      fit: "500 ml",
      care: "Mist into the air away from flames, fabrics and polished surfaces",
      sustainability: "Recyclable glass bottle",
    },
    features: [
      "500 ml room fragrance",
      "Fine-mist trigger",
      "Woody mineral scent profile",
    ],
    tags: ["homeware", "room-sprays", "fragrance", "cedar"],
    rating: 4.7,
    reviewCount: 19,
    stock: 32,
    isNew: false,
  },
  {
    id: 26,
    slug: "cedar-glow-scented-candle",
    sku: "TL26-026",
    name: "cedar glow scented candle",
    category: "Candles",
    price: 119.9,
    currency: "USD",
    image: "/img/products/26-cedar-glow-scented-candle.jpg",
    images: ["/img/products/26-cedar-glow-scented-candle.jpg"],
    description: [
      "A softly scented candle balancing cedarwood, warm resin and a subtle veil of clean musk.",
      "The steady cotton wick and vegetable wax blend create an even glow for slow evenings and quiet mornings.",
    ],
    sizes: oneSize,
    colors: ["Amber Glass"],
    attributes: {
      material: "Vegetable wax blend in a reusable glass vessel",
      fit: "220 g",
      care: "Trim the wick to 5 mm before lighting and never leave unattended",
      sustainability: "Reusable glass vessel",
    },
    features: [
      "Approximately 45-hour burn time",
      "Lead-free cotton wick",
      "Woody amber scent profile",
    ],
    tags: ["homeware", "candles", "fragrance", "cedar"],
    rating: 4.8,
    reviewCount: 27,
    stock: 44,
    isNew: false,
  },
  {
    id: 27,
    slug: "irregular-stripe-pillow-cover-50x50",
    sku: "TL26-027",
    name: "irregular stripe pillow cover 50x50",
    category: "Pillow covers",
    price: 109.9,
    currency: "USD",
    image: "/img/products/27-pillow-cover-stripes.jpg",
    images: ["/img/products/27-pillow-cover-stripes.jpg"],
    description: [
      "A square cotton pillow cover with an original irregular stripe layout in softened monochrome tones.",
      "The substantial woven texture brings quiet pattern to a sofa, reading chair or layered bed setting.",
    ],
    sizes: oneSize,
    colors: ["Ecru / Black"],
    attributes: {
      material: "100% cotton canvas",
      fit: "50 × 50 cm",
      care: "Machine wash inside out at 30°C",
      sustainability: "Durable natural-fibre construction",
    },
    features: [
      "Fits a 50 × 50 cm insert",
      "Concealed zip closure",
      "Original woven stripe layout",
    ],
    tags: ["homeware", "pillow-covers", "stripes", "365"],
    rating: 4.7,
    reviewCount: 23,
    stock: 30,
    isNew: false,
  },
  {
    id: 28,
    slug: "quilted-field-jacket",
    sku: "TL26-028",
    name: "quilted field jacket",
    category: "Jackets",
    price: 219.9,
    currency: "USD",
    image: "/img/products/28-quilted-field-jacket.jpg",
    images: ["/img/products/28-quilted-field-jacket.jpg"],
    description: [
      "A lightweight field jacket shaped with subtle diamond quilting, a neat stand collar and softly curved pockets.",
      "The recycled shell adds comfortable warmth without bulk, making it an easy layer between seasons.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["XXS", "2XL"],
    colors: ["Dusty Olive", "Black"],
    attributes: {
      material: "Recycled polyamide shell with recycled fill",
      fit: "Relaxed hip-length fit",
      care: "Gentle machine wash at 30°C; dry flat",
      sustainability: "Recycled shell and insulation",
    },
    features: ["Light diamond quilting", "Curved patch pockets", "Snap front and stand collar"],
    tags: ["new", "women", "jackets", "outerwear", "recycled"],
    rating: 4.8,
    reviewCount: 18,
    stock: 26,
    isNew: true,
  },
  {
    id: 29,
    slug: "soft-wrap-cardigan",
    sku: "TL26-029",
    name: "soft wrap cardigan",
    category: "Cardigans",
    price: 149.9,
    currency: "USD",
    image: "/img/products/29-soft-wrap-cardigan.jpg",
    images: ["/img/products/29-soft-wrap-cardigan.jpg"],
    description: [
      "A softly structured wrap cardigan with roomy sleeves, dropped shoulders and a wide self-tie belt.",
      "The brushed recycled-wool blend brings gentle warmth to relaxed trousers, dresses and everyday layers.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["XXS"],
    colors: ["Oatmeal", "Charcoal"],
    attributes: {
      material: "Recycled wool and organic cotton blend",
      fit: "Relaxed wrap fit",
      care: "Hand wash cold; reshape and dry flat",
      sustainability: "Recycled wool content",
    },
    features: ["Wide removable belt", "Dropped shoulders", "Deep side pockets"],
    tags: ["new", "women", "cardigans", "knit", "layering"],
    rating: 4.9,
    reviewCount: 22,
    stock: 34,
    isNew: true,
  },
  {
    id: 30,
    slug: "fluid-midi-dress",
    sku: "TL26-030",
    name: "fluid midi dress",
    category: "Dresses",
    price: 169.9,
    currency: "USD",
    image: "/img/products/30-fluid-midi-dress.jpg",
    images: ["/img/products/30-fluid-midi-dress.jpg"],
    description: [
      "A fluid midi dress with a softly gathered waist, cuffed sleeves and an asymmetric sense of movement through the skirt.",
      "Breathable lyocell twill creates an easy drape for daytime plans, dinners and travel wardrobes.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["2XL"],
    colors: ["Ink Blue", "Warm Sand"],
    attributes: {
      material: "100% responsibly sourced lyocell",
      fit: "Regular fit with gathered waist",
      care: "Gentle machine wash at 30°C; hang dry",
      sustainability: "Lower-impact lyocell fibre",
    },
    features: ["Midi-length skirt", "Soft gathered waist", "Buttoned cuffs"],
    tags: ["new", "women", "dresses", "lyocell", "occasion"],
    rating: 4.8,
    reviewCount: 16,
    stock: 29,
    isNew: true,
  },
  {
    id: 31,
    slug: "ribbed-studio-jumpsuit",
    sku: "TL26-031",
    name: "ribbed studio jumpsuit",
    category: "Jumpsuits",
    price: 159.9,
    currency: "USD",
    image: "/img/products/31-ribbed-studio-jumpsuit.jpg",
    images: ["/img/products/31-ribbed-studio-jumpsuit.jpg"],
    description: [
      "A sleeveless ribbed jumpsuit designed with a clean neckline, adjustable waist tie and relaxed straight leg.",
      "Soft stretch jersey makes the one-piece silhouette comfortable for long days while retaining a polished line.",
    ],
    sizes: apparelSizes,
    colors: ["Charcoal", "Stone"],
    attributes: {
      material: "Organic cotton rib with elastane",
      fit: "Relaxed straight fit",
      care: "Machine wash at 30°C with similar colours",
      sustainability: "Organic cotton content",
    },
    features: ["Adjustable waist tie", "Straight full-length leg", "Side-entry pockets"],
    tags: ["new", "women", "jumpsuits", "rib", "travel"],
    rating: 4.7,
    reviewCount: 14,
    stock: 21,
    isNew: true,
  },
  {
    id: 32,
    slug: "crescent-day-bag",
    sku: "TL26-032",
    name: "crescent day bag",
    category: "Bags",
    price: 149.9,
    currency: "USD",
    image: "/img/products/32-crescent-day-bag.jpg",
    images: ["/img/products/32-crescent-day-bag.jpg"],
    description: [
      "A softly curved day bag with a wide adjustable strap and a concealed top zip for everyday essentials.",
      "The recycled woven textile is light, durable and comfortable to wear close to the body.",
    ],
    sizes: oneSize,
    colors: ["Clay", "Dark Fog"],
    attributes: {
      material: "Recycled polyester canvas with cotton lining",
      fit: "34 × 22 × 9 cm",
      care: "Spot clean with a damp cloth",
      sustainability: "Recycled outer fabric",
    },
    features: ["Adjustable shoulder strap", "Concealed zip closure", "Internal slip pocket"],
    tags: ["new", "women", "bags", "accessories", "recycled"],
    rating: 4.8,
    reviewCount: 25,
    stock: 38,
    isNew: true,
  },
  {
    id: 33,
    slug: "woven-canvas-tote",
    sku: "TL26-033",
    name: "woven canvas tote",
    category: "Bags",
    price: 139.9,
    currency: "USD",
    image: "/img/products/33-woven-canvas-tote.jpg",
    images: ["/img/products/33-woven-canvas-tote.jpg"],
    description: [
      "A substantial organic-cotton canvas tote built with deep side gussets and reinforced contrast handles.",
      "The generous unprinted design carries workday layers, market finds and weekend essentials without fuss.",
    ],
    sizes: oneSize,
    colors: ["Ecru / Black"],
    attributes: {
      material: "Heavyweight organic cotton canvas",
      fit: "42 × 34 × 14 cm",
      care: "Spot clean; air dry",
      sustainability: "Organic cotton canvas",
    },
    features: ["Reinforced handles", "Deep side gussets", "Internal key pocket"],
    tags: ["women", "men", "bags", "accessories", "organic-cotton"],
    rating: 4.7,
    reviewCount: 31,
    stock: 47,
    isNew: false,
  },
  {
    id: 34,
    slug: "brushed-merino-beanie",
    sku: "TL26-034",
    name: "brushed merino beanie",
    category: "Hats",
    price: 109.9,
    currency: "USD",
    image: "/img/products/34-brushed-merino-beanie.jpg",
    images: ["/img/products/34-brushed-merino-beanie.jpg"],
    description: [
      "A fine-rib merino beanie with a lightly brushed finish and a wide folded cuff for adjustable coverage.",
      "Its soft, breathable knit adds warmth without weight and packs neatly for colder journeys.",
    ],
    sizes: oneSize,
    colors: ["Dusty Rose", "Charcoal"],
    attributes: {
      material: "Responsible wool standard merino",
      fit: "One size; stretch fit",
      care: "Hand wash cold; dry flat",
      sustainability: "Certified responsible wool",
    },
    features: ["Wide fold-over cuff", "Fine rib construction", "Soft brushed surface"],
    tags: ["new", "women", "hats", "accessories", "merino"],
    rating: 4.9,
    reviewCount: 20,
    stock: 41,
    isNew: true,
  },
  {
    id: 35,
    slug: "slim-leather-belt",
    sku: "TL26-035",
    name: "slim leather belt",
    category: "Belts",
    price: 129.9,
    currency: "USD",
    image: "/img/products/35-slim-leather-belt.jpg",
    images: ["/img/products/35-slim-leather-belt.jpg"],
    description: [
      "A slim everyday belt cut from vegetable-tanned leather and finished with an original rounded matte-metal buckle.",
      "The understated proportion works through trouser loops or over relaxed dresses and knit layers.",
    ],
    sizes: ["75 cm", "85 cm", "95 cm", "105 cm"],
    colors: ["Black", "Dark Brown"],
    attributes: {
      material: "Vegetable-tanned bovine leather",
      fit: "25 mm width",
      care: "Wipe clean and condition with neutral leather care",
      sustainability: "Long-wearing natural material",
    },
    features: ["Original rounded buckle", "Five adjustment holes", "Painted tonal edges"],
    tags: ["women", "men", "belts", "accessories", "leather"],
    rating: 4.6,
    reviewCount: 12,
    stock: 36,
    isNew: false,
  },
  {
    id: 36,
    slug: "relaxed-overshirt-dress",
    sku: "TL26-036",
    name: "relaxed overshirt dress",
    category: "Dresses",
    price: 179.9,
    currency: "USD",
    image: "/img/products/36-relaxed-overshirt-dress.jpg",
    images: ["/img/products/36-relaxed-overshirt-dress.jpg"],
    description: [
      "A midi overshirt dress with a curved hem, clean button front and removable self-fabric belt.",
      "Washed organic-cotton canvas gives the relaxed shape enough substance to wear alone or open as a light layer.",
    ],
    sizes: apparelSizes,
    unavailableSizes: ["XXS", "XL"],
    colors: ["Warm Stone", "Dusty Olive"],
    attributes: {
      material: "Washed organic cotton canvas",
      fit: "Relaxed midi fit",
      care: "Machine wash at 30°C; reshape while damp",
      sustainability: "Organic cotton",
    },
    features: ["Removable waist belt", "Curved side-slit hem", "Full button front"],
    tags: ["new", "women", "dresses", "shirts", "layering"],
    rating: 4.8,
    reviewCount: 17,
    stock: 24,
    isNew: true,
  },
  {
    id: 37,
    slug: "fine-rib-base-layer",
    sku: "TL26-037",
    name: "fine rib base layer",
    category: "T-shirts",
    price: 119.9,
    currency: "USD",
    image: "/img/products/37-fine-rib-base-layer.jpg",
    images: ["/img/products/37-fine-rib-base-layer.jpg"],
    description: [
      "A fitted long-sleeve base layer in fine organic-cotton rib with a clean crew neckline and extended cuffs.",
      "The breathable stretch fabric follows the body comfortably beneath shirts, knits and jackets.",
    ],
    sizes: apparelSizes,
    colors: ["Cocoa", "Ecru", "Black"],
    attributes: {
      material: "95% organic cotton, 5% elastane",
      fit: "Close stretch fit",
      care: "Machine wash at 30°C with similar colours",
      sustainability: "Organic cotton content",
    },
    features: ["Fine rib texture", "Extended clean cuffs", "Soft curved hem"],
    tags: ["new", "women", "t-shirts", "base-layer", "organic-cotton"],
    rating: 4.7,
    reviewCount: 28,
    stock: 52,
    isNew: true,
  },
];

export default productData;
